import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const scSideNav = {
  id: 'sc',
  shortName: 'S & C',
  role: 'SC_VIEW',
  displayName: 'Sales & Concessions',
  icon: fas.faMoneyCheckAlt,
  precedence: 1,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('sc'),

    // Direct Sales
    {
      id: 'scDirSalesMenu',
      displayName: 'Direct Sales',
      role: 'SC_DIR_SALE_VIEW',
      icon: fas.faFileInvoice,
      precedence: 1,
      children: [
        {
          id: 'scDirSaleFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/dir-sale-fin-dashboard',
          precedence: 1,
        },
        {
          id: 'scDirSale',
          displayName: 'Sales',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/dir-sale',
          precedence: 2,
        },
        {
          id: 'scDirSaleLines',
          displayName: 'Sale Lines',
          role: 'SC_DIR_SALE_LINE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/dir-sale-line',
          precedence: 3,
        },
        {
          id: 'scAdj',
          displayName: 'Adjustments',
          role: 'SC_ADJ_VIEW',
          icon: fas.faSlidersHSquare,
          route: '/sc/adj',
          precedence: 4,
        },
        {
          id: 'scAdjLines',
          displayName: 'Adjustment Lines',
          role: 'SC_ADJ_LINE_VIEW',
          icon: fas.faSlidersHSquare,
          route: '/sc/adj-line',
          precedence: 5,
        },
      ],
    },

    // Chargeback Section
    {
      id: 'scChbkMenu',
      displayName: 'Chargebacks',
      role: 'SC_CHBK_LEDGER_VIEW',
      icon: fas.faWarehouse,
      precedence: 2,
      children: [
        {
          id: 'scIndirSaleFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_INDIR_SALE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/indir-sale-fin-dashboard',
          precedence: 1,
        },
        {
          id: 'scIndirSale',
          displayName: 'Indirect Sales',
          role: 'SC_INDIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/indir-sale',
          precedence: 2,
        },
        {
          id: 'scIndirSaleLines',
          displayName: 'Indirect Sale Lines',
          role: 'SC_INDIR_SALE_LINE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/indir-sale-line',
          precedence: 3,
        },
        {
          id: 'scChbk',
          displayName: 'Chargebacks',
          role: 'SC_CHBK_VIEW',
          icon: fas.faClipboard,
          route: '/sc/chbk',
          precedence: 4,
        },
        {
          id: 'scChbkLedger',
          displayName: 'Ledgers',
          role: 'SC_CHBK_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/chbk-ledger',
          precedence: 5,
        },
        {
          id: 'scChbkPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/chbk',
          precedence: 6,
        },
        {
          id: 'scChannelData',
          displayName: 'Channel Data',
          role: 'SC_CHANNEL_DATA_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/channel-data',
          precedence: 7,
        },
        {
          id: 'scShpmnt',
          displayName: 'Shipments',
          role: 'SC_SHPMNT_VIEW',
          icon: fas.faBoxOpen,
          route: '/sc/shpmnt',
          precedence: 8,
        },
        {
          id: 'scAcctBal',
          displayName: 'Account Balance',
          role: 'SC_ACCT_BAL_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/acct-bal',
          precedence: 9,
        },
      ],
    },

    // Incentive Section
    {
      id: 'scInctvMenu',
      displayName: 'Incentive',
      role: 'SC_INCTV_LEDGER_VIEW',
      icon: fas.faTag,
      precedence: 3,
      children: [
        {
          id: 'scInctvRbtFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_INCTV_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/inctv-rbt-fin-dashboard',
          precedence: 1,
        },
        {
          id: 'scInctvRbt',
          displayName: 'Rebates',
          role: 'SC_INCTV_RBT_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/inctv-rbt',
          precedence: 2,
        },
        {
          id: 'scInctvRbtLines',
          displayName: 'Rebate Lines',
          role: 'SC_INCTV_RBT_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/inctv-rbt-line',
          precedence: 3,
        },

        {
          id: 'scInctvLedger',
          displayName: 'Ledgers',
          role: 'SC_INCTV_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/inctv-ledger',
          precedence: 4,
        },
        {
          id: 'scInctvLedgerLine',
          displayName: 'Ledger Lines',
          role: 'SC_INCTV_LEDGER_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/inctv-ledger-line',
          precedence: 5,
        },
        {
          id: 'scInctvPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/inctv',
          precedence: 6,
        },
      ],
    },
    {
      id: 'scDsaMenu',
      displayName: 'DSA',
      role: 'SC_INCTV_LEDGER_VIEW',
      icon: fas.faTag,
      precedence: 4,
      children: [
        {
          id: 'scInctvDashboard',
          displayName: 'DSA/SD Dashboard',
          role: 'SC_INCTV_LEDGER_VIEW',
          icon: fas.faChartLine,
          route: '/sc/dashboard/inctv-ledger',
          precedence: 1,
        },
      ],
    },

    // Managed Care Section
    {
      id: 'scMcoMenu',
      displayName: 'Managed Care',
      role: 'SC_MCO_LEDGER_VIEW',
      icon: fas.faClinicMedical,
      precedence: 5,
      children: [
        {
          id: 'scMcoInvFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-inv-fin-dashboard',
          precedence: 1,
        },
        {
          id: 'scMcoInv',
          displayName: 'Invoices',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mco-inv',
          precedence: 2,
        },
        {
          id: 'scMcoInvLines',
          displayName: 'Invoice Lines',
          role: 'SC_MCO_INV_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-inv-line',
          precedence: 3,
        },
        {
          id: 'scMcoRbt',
          displayName: 'Rebates',
          role: 'SC_MCO_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-rbt',
          precedence: 4,
        },
        {
          id: 'scMcoLedger',
          displayName: 'Ledgers',
          role: 'SC_MCO_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mco-ledger',
          precedence: 5,
        },
        {
          id: 'scMcoPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mco',
          precedence: 6,
        },
      ],
    },

    // Medicaid Section
    {
      id: 'scMcdMenu',
      displayName: 'Medicaid',
      role: 'SC_MCD_INV_VIEW',
      icon: fas.faHospitalUser,
      precedence: 6,
      children: [
        {
          id: 'scMcdFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv-fin-dashboard',
          precedence: 1,
        },
        {
          id: 'scMcdInv',
          displayName: 'Invoices',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv',
          precedence: 2,
        },
        {
          id: 'scMcdInvLines',
          displayName: 'Invoice Lines',
          role: 'SC_MCD_INV_LINE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv-line',
          precedence: 3,
        },
        {
          id: 'scMcdRbt',
          displayName: 'Rebates',
          role: 'SC_MCD_RBT_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-rbt',
          precedence: 4,
        },
        {
          id: 'scMcdLedger',
          displayName: 'Ledgers',
          role: 'SC_MCD_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mcd-ledger',
          precedence: 5,
        },

        {
          id: 'scMcdPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mcd',
          precedence: 6,
        },
      ],
    },

    // MFP Section
    {
      id: 'scMfpMenu',
      displayName: 'MFP',
      role: 'SC_MFP_VIEW',
      icon: fas.faNotesMedical,
      precedence: 7,
      children: [
        {
          id: 'scMfpBoard',
          displayName: 'Lifecycle Board',
          role: 'SC_MFP_LEDGER_VIEW',
          icon: fas.faChartBar,
          route: '/sc/board/mfp-ledger',
          precedence: 1,
        },
        {
          id: 'scMfpUtil',
          displayName: 'Utilizations',
          role: 'SC_MFP_UTIL_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mfp-util',
          precedence: 2,
        },
        {
          id: 'scMfpLedger',
          displayName: 'Ledgers',
          role: 'SC_MFP_LEDGER_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mfp-ledger',
          precedence: 3,
        },
        {
          id: 'scMfpPymt',
          displayName: 'Payments',
          role: 'SC_MFP_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/mfp-pymt',
          precedence: 4,
        },
        {
          id: 'scMfpCredit',
          displayName: 'Credits',
          role: 'SC_MFP_CREDIT_VIEW',
          icon: fas.faHandsUsd,
          route: '/sc/mfp-credit',
          precedence: 5,
        },
      ],
    },
    // External Data
    {
      id: 'extData',
      displayName: 'External Data',
      role: 'SC_EXT_DATA_VIEW',
      icon: fas.faListUl,
      precedence: 8,
      children: [
        {
          id: 'scBrgDupDiscCheck',
          displayName: 'BRG Duplicate Checks',
          role: 'SC_BRG_DUP_DISC_CHECK_VIEW',
          icon: fas.faClipboard,
          route: '/sc/brg-dup-disc-check',
          precedence: 1,
        },
      ],
    },

    // Common Menus
    ...SidenavUtils.commonMenus('sc'),
  ],
};

export default scSideNav;
